import { useAtomValue, useSetAtom } from 'jotai';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { ActionBar } from '@/lib/components/ActionBar';
import { Button, Flex, Text } from '@/lib/v2/components';
import { CopyIcon, PencilIcon, RemoveIcon } from '@/lib/v2/icons/solid';

import {
  atomSelectedRowsWithID,
  atomTotalSelectedRows,
} from '@/modules/CampaignsModule/atoms/campaignAtom';
import {
  atomModalTypeProcess,
  atomToggleDeleteModal,
  atomToggleEditCreateCampaignModal,
} from '@/modules/CampaignsModule/atoms/modalsCampaignAtom';
import { useCampaign } from '@/modules/CampaignsModule/hooks/useCampaigns';
import { IActionIcon, ModalType } from '@/modules/CampaignsModule/interfaces/Campaigns';

const ActionBarButtons = () => {
  const { t } = useTranslation();
  const { getDetailCampaign } = useCampaign();

  const totalSelectedRows = useAtomValue(atomTotalSelectedRows);
  const selectedRowsWithID = useAtomValue(atomSelectedRowsWithID);
  const setToggleDeleteModal = useSetAtom(atomToggleDeleteModal);
  const setModalTypeProcess = useSetAtom(atomModalTypeProcess);
  const setToggleEditCategoryModal = useSetAtom(atomToggleEditCreateCampaignModal);

  const handleModalDeleteCampaigns = useCallback(() => {
    setToggleDeleteModal(true);
  }, [setToggleDeleteModal]);

  const handleClickEditCampaign = useCallback(() => {
    if (totalSelectedRows > 1) return;

    void getDetailCampaign({ campaignID: Number(selectedRowsWithID[0]) });
    setModalTypeProcess(ModalType.EDIT);
    setToggleEditCategoryModal(true);
  }, [
    getDetailCampaign,
    selectedRowsWithID,
    setModalTypeProcess,
    setToggleEditCategoryModal,
    totalSelectedRows,
  ]);

  const ICONS_LIST_ACTIONS: IActionIcon[] = [
    {
      icon: <PencilIcon />,
      onClick: handleClickEditCampaign,
      tooltip: t('CAMPAIGNS_MAIN.ACTIONS.tooltipEdit'),
      hide: totalSelectedRows > 1,
      id: 'edit-campaign',
    },
    {
      icon: <CopyIcon />,
      onClick: () => {
        console.log('Duplicate campaign-action');
      },
      tooltip: t('CAMPAIGNS_MAIN.ACTIONS.tooltipDuplicate'),
      hide: totalSelectedRows > 1,
      id: 'duplicate-campaign-action',
    },
    {
      icon: <RemoveIcon />,
      onClick: handleModalDeleteCampaigns,
      tooltip: t('CAMPAIGNS_MAIN.ACTIONS.tooltipDelete'),
      hide: false,
      id: 'delete-campaign',
    },
  ];

  return (
    <Flex alignment="start" className=" wrapperButtons z-10 mb-[-72px] !h-14">
      <ActionBar>
        <Flex alignment="start" className="px-4">
          <Flex className="min-w-[120px]">
            <Text color="white" variant="text-sm">
              {totalSelectedRows > 1
                ? `${totalSelectedRows} ${t('CAMPAIGNS_MAIN.ACTIONS.selected')}`
                : `${totalSelectedRows} ${t('CAMPAIGNS_MAIN.ACTIONS.select')}`}
            </Text>
          </Flex>
          <Flex withGap alignment="start" gapSize="small">
            {ICONS_LIST_ACTIONS.map((element) => {
              const { icon, hide, tooltip, onClick: handleOnClick, id } = element;
              return (
                <>
                  {!hide && (
                    <div key={id}>
                      <Button
                        fullWidth
                        outline
                        standard
                        iconLeft={icon}
                        id={id}
                        tooltip={tooltip}
                        onClick={handleOnClick}
                      />
                    </div>
                  )}
                </>
              );
            })}
          </Flex>
        </Flex>
      </ActionBar>
    </Flex>
  );
};

export default ActionBarButtons;
